var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategoryIconBrandColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8.75H12.6667C13.3333 8.75 13.75 8 13.3333 7.5L10.25 2.41666C9.91667 1.91666 9.16667 1.91666 8.83333 2.41666L5.75 7.5C5.41667 8.08333 5.83333 8.75 6.5 8.75V8.75Z",
    fill: "#FB607F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 17.9167C16.2377 17.9167 17.9167 16.2377 17.9167 14.1667C17.9167 12.0956 16.2377 10.4167 14.1667 10.4167C12.0956 10.4167 10.4167 12.0956 10.4167 14.1667C10.4167 16.2377 12.0956 17.9167 14.1667 17.9167Z",
    fill: "#FB607F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 10.8333H2.91667C2.5 10.8333 2.08334 11.25 2.08334 11.6667V16.6667C2.08334 17.0833 2.5 17.5 2.91667 17.5H7.91667C8.33334 17.5 8.75 17.0833 8.75 16.6667V11.6667C8.75 11.25 8.33334 10.8333 7.91667 10.8333Z",
    fill: "#FB607F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryIconBrandColor);
export default __webpack_public_path__ + "static/media/category-icon-brand-color.27e453cde120202c237d9e07cbb51655.svg";
export { ForwardRef as ReactComponent };